export default __webpack_public_path__ + "static/media/mirage.055940a9.png";